import ContentHeading from "../content-heading";
import { wrapper, image, content, subheading } from "./styles/image-hero";
import scss from "@/styles/pages/webinars/image-hero.module.scss"

const ImageHero: React.FC = () => {
  return (
    <div className={wrapper}>
      <div className={scss["image-box"]}>
        <img
          className={image}
          srcSet={`
            /assets/images/webinars/small.webp 420w, 
						/assets/images/webinars/small.jpg 420w,
						/assets/images/webinars/medium.webp 733w, 
						/assets/images/webinars/medium.jpg 733w,
						/assets/images/webinars/large.webp 1465w,
						/assets/images/webinars/large.jpg 1465w,
					`}
          sizes="(max-width:736px) 420px, (max-width:1280px) 800px, 1500px"
          src={`/assets/images/webinars/small.jpg`}
          title="hearX Group webinar page"
          alt="Male watching hearX's webinars featuring informative &amp; insightful topics."
        />
      </div>

      <div className={content}>
        <ContentHeading
          h="p"
          className="mobile:justify-start tablet:justify-start"
          backdropPosition="mobile:left-4 tablet:left-8"
          fontSize="mobile:text-xl tablet:text-5xl"
          background="bg-primary bg-opacity-50"
        >
          Webinars
        </ContentHeading>
        <p className={subheading}>
        Watch our webinars on informative and insightful topics.
        </p>
      </div>
    </div>
  );
};

export default ImageHero;
